module.exports = __webpack_public_path__ + "static/media/018-Verlassen_ID_3.a490dbdd.mp3";